import { render, staticRenderFns } from "./goodsAdd.vue?vue&type=template&id=6bcad425&"
import script from "./goodsAdd.vue?vue&type=script&lang=js&"
export * from "./goodsAdd.vue?vue&type=script&lang=js&"
import style0 from "./goodsAdd.vue?vue&type=style&index=0&id=6bcad425&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports